/**
 * GCSE icon styles
 */
export const circleStyles = [
  "tw-bg-white tw-border-primary-blue tw-text-primary-blue",
  "tw-bg-white tw-border-primary-yellow tw-text-primary-yellow",
  "tw-bg-primary-blue tw-text-white tw-border-primary-blue",
  "tw-bg-primary-yellow tw-text-white tw-border-primary-yellow",
];

/**
 * Mapping for each word of GCSE
 */
export const gcse_content = [
  {
    letter: "G",
    content: `The goal is what you want the AI to do. It explains the main task simply and directly. A good goal helps the AI understand exactly what 
      kind of answer you are looking for. For example, instead of saying “Tell me about history,” a better goal would be “explain the causes of 
      World War I.” Clear goals lead to better and more useful responses.`,
  },
  {
    letter: "C",
    content: `Context gives background information that helps the AI understand the situation. This can include details like who the audience is, 
      what you already know, or why you need the answer. Adding context helps the AI give a more accurate and relevant response. For example, 
      saying “explain this to a beginner” or “I'm studying for a test” helps shape the answer.`,
  },
  {
    letter: "S",
    content: `Sources tell the AI where to get information from or what kind of information to use. You can ask the AI to use certain types of sources, 
      like textbooks, research studies, or examples. This helps make the answer more reliable and focused. Even if the AI is not directly citing 
      sources, this guidance improves the response quality.`,
  },
  {
    letter: "E",
    content: `Expectations explain how you want the answer to look. This includes things like length, tone, format, or level of detail. For example, 
      you might ask for a short paragraph, a bullet list, or simple language. Setting expectations makes sure the answer matches what you need 
      and is easy to understand.`,
  },
];
